// extracted by mini-css-extract-plugin
export default {"list":"PairsPicker_list__A3ces"};